import { makeStyles } from '@mui/styles';
import { padEnd } from 'lodash';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 56,
    minHeight: '100%',
    height: 'fit-content',
    [theme.breakpoints.up('sm')]: {
      marginTop: 64,
    },
    backgroundColor: '#f5f7fa',
  },


  contentPage: {
    display: 'flex',
  },
  sidebarMobile: {
    '@media(max-width: 550px)': {
      position: 'fixed',
      left: '-100%',
      top: '0',
      height: '100%',
      transitionDuration: '500ms',
      zIndex: '100',
      transform: 'translate(0, 0)',



    },

    '&.showmenuMobile': {
      '@media(max-width: 550px)': {
        left: '0',

      }
    },
  },

  copyWrite: {
    width: '100%',
    position: 'relative',
    bottom: '-63px',
    height: '40px',
    lineHeight: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    '@media(max-width: 550px)': {
      display: 'block',
      lineHeight: '30px',
      height: '30px',
      textAlign: 'center',
      marginBottom: '35px',



    },

  },
  contentParent: {
    minHeight: '82.4vh',
  },
  copyWriteText: {
    color: '#afafaf',
    fontSize: '13px',
    fontWeight: '100',
    '& a': {
      color: '#999',
      margin: '0 4px',
      fontWeight: '600',
      transitionDuration: '200ms',

      '&:hover': {
        color: '#3b4ba5',
        transitionDuration: '200ms',


      }

    }

  },

  content: {
    height: '100%',
    position: 'relative',
    margin: '0 32px',
    minHeight: 'calc(100vh - 210px)',
    width: 'calc(100% - 178px)',
    transitionDuration: '500ms',
    [theme.breakpoints.down('md')]: {
      margin: 0,
      padding: 16,
    },
    '@media(max-width: 550px)': {
      width: '100%!important',

    },
    '&.showContent': {
      width: 'calc(100% - 420px)!important',
      transitionDuration: '500ms',
      '@media(max-width: 550px)': {
        width: '100%!important',
      },

    },
  },

}));

export const useStylesSkeleton = makeStyles((theme) => ({
  root: {
    height: '100%',
  },

  content: {
    height: '100%',
  },
}));
